import React from 'react';
import s from './UploadKYC.module.css'
import { NavLink } from 'react-router-dom';
import MyBtn from "../ui/MyBtn/MyBtn";
import logo from "../../assets/img/personalAccount/logo_sign-in.svg";
import {motion} from "framer-motion";
import {myDate} from "../../helpers/CalculateDate";

const UploadKYC: React.FC = () => {

    const currentYear = myDate.getFullYear()

    const redirect = (type: string) => {
        if (type === 'personal') {
            window.open('https://idv.ondato.com/setups/b0c6a290-9dc5-4fed-a6dd-626d8ce5dd8d', '_blank');
        } else {
            window.open('https://idv.ondato.com/setups/46806af1-8cfb-4458-ac93-9f5955d9d718', '_blank');
        }
    }

    return (

        <motion.div
            initial={{opacity: 0, scale: 1}}
            animate={{opacity: 1, scale: 1}}
            transition={{duration: 0.5}}
        >

            <div className={s.wrapper_bg}>
                <div className={s.wrapper_bg_body}>

                    <div className={s.signup_wrapper_content_none}>
                        <div className={s.content_left}>
                            <div className={s.logo_block}>
                                <NavLink to={"/"}>
                                    <img src={logo} alt=""/>
                                </NavLink>
                            </div>
                            <div className={s.welcome_block}>
                                Welcome to <br/>
                                LuxPay!
                            </div>
                            <div className={s.welcome_block_mobile}>
                                Welcome to LuxPay!
                            </div>
                        </div>
                    </div>
                    <div className={s.signup_wrapper_content_full}>
                        <div className={s.account_select}>
                            <div className={s.account_content}>
                                <div className={s.account_selection}>
                                    <div className={s.account_selection_title}>Please select account type</div>
                                    <div className={s.account_selection_content}>
                                        <div className={s.account_selection_item}>
                                            <div className={s.item_personal_image}></div>
                                            <div className={s.item_title}>Personal</div>
                                            <div className={s.item_description}>
                                                Manage your personal finances your way – the convenient way,
                                                the flexible way, the LuxPay way.
                                            </div>
                                            <div className={s.item_button}>
                                                <MyBtn title='Private client'
                                                       large
                                                       isPersonalAccountBtn
                                                       onClick={() => redirect("personal")}
                                                       type={"submit"}/>
                                            </div>
                                        </div>
                                        <div className={s.account_selection_item}>
                                            <div className={s.item_business_image}></div>
                                            <div className={s.item_title}>Business</div>
                                            <div className={s.item_description}>
                                                Advance financial operations of your business with our
                                                competitive prices and expert service.
                                            </div>
                                            <div className={s.item_button}>
                                                <MyBtn title='Business client'
                                                       large
                                                       isPersonalAccountBtn
                                                       onClick={() => redirect("business")}
                                                       type={"submit"}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={s.account_back}>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className={s.footer_text}>
                    All rights reserved © {currentYear} Lux International Payment System, UAB License No. 81.&nbsp;
                    <a href="https://www.lb.lt/en/sfi-financial-market-participants/uab-lux-international-payment-system"
                       className={s.licence_link}>Bank of Lithuania</a>
                </div>
            </div>
        </motion.div>


    );
};

export default UploadKYC;
